import { render, staticRenderFns } from "./UserAvatarMenu.vue?vue&type=template&id=245024ec&scoped=true"
import script from "./UserAvatarMenu.vue?vue&type=script&lang=js"
export * from "./UserAvatarMenu.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarMenu.vue?vue&type=style&index=0&id=245024ec&prod&lang=scss&scoped=true"
import style1 from "./UserAvatarMenu.vue?vue&type=style&index=1&id=245024ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245024ec",
  null
  
)

export default component.exports